<!--锂电池列表 -->
<template>
  <div id="charges" style="background: #fff;">

    <!-- 搜索 -->
    <div id="search" class="filter-container" style="padding-left:20px;">
      <el-input v-model="listQuery.name" clearable :placeholder="$t('liBattery.DeviceName')" class="input-with-select deviceNameTable" @clear="searchTable">
        <el-button slot="append" icon="el-icon-search" @click="searchTable" />
      </el-input>
    </div>

    <!-- 分页表格 -->
    <div class="app-container" style="padding-top:0;">
      <el-table id="chargesTable" v-loading.body="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
        <el-table-column :label="$t('liBattery.DeviceName')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('liBattery.UpdateTime')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.UpdateAt }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('QR.Uploader')" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.updateBy }}</span>
          </template>
        </el-table-column>

        <el-table-column :label="$t('yhubReport.Operating')" align="center">
          <template slot-scope="scope">
          <el-button type="text" size="small" @click.native.prevent="view(scope.row.name)">
              {{ $t('liBattery.ViewData') }}
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          current-page.sync="listQuery.pageInfo.page"
          :page-sizes="listQuery.pageInfo.pageList"
          :page-size="listQuery.pageInfo.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="listQuery.pageInfo.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>

    </div>
  </div>
</template>

<script>
import { queryKisaeInfo } from '@/api/blueTooth'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime'

export default {
  data() {
    return {
      list: [],
      listLoading: true,
      listQuery: {
        name: null,
        pageInfo: pagination()
      },
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    queryList() {
      this.listLoading = true
      // console.log(this.listQuery)
      var param = {
        name: this.listQuery.name,
        pageNum: this.listQuery.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      queryKisaeInfo(param).then(response => {
        this.list = response.resultModel.list
        this.list.forEach(v => {
          v.UpdateAt = getDateAndHour(v.updateTime)
        })
        this.listQuery.pageInfo.total = response.resultModel.total
        this.listLoading = false
      })
    },
    searchTable() {
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    handleSizeChange(val, e) {
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) {
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    },
    selectChange(selection) {
      this.itemIds = selection
    },
    view(name) {
      console.log(name)
      this.$router.push({
        path: '/kisae/kisaeDataDetail?name=' + name
      })
    }
  }
}
</script>
<style lang="scss">
#chargesTable{
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  .el-table__expand-column{
    border-right:none;
  }
}
#bindCompany{
  .el-input{
    width:80%;
  }
  .el-select{
    width:100%;
  }
}
#charges{
  #search .el-input-group {
    width: 40%!important;
    max-width: 300px!important;
    margin-top: 13px;
  }
}
.editPop{
  .el-form-item--medium .el-form-item__content{
    width: 240px;
  }
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
    width:100%;
  }
}
</style>
